module.exports = __webpack_public_path__ + "img/lo-studio-image-2.00daf7c5.png";